<template lang="pug">
div
  .coupons-container(
    :class="{ 'disabled-coupon': isDisabled, 'vip-unopen-card-content': !vipOpen, 'vip-open-card-content': vipOpen,}"
    @click="openChangeModal()"
  )
    .title
      .title-content
        img( v-if="freeRightsVersion()" :src='item.propIcon')
        span {{ getGoodsPropDesc() }}
    template(v-if="!getAward() && !showFreeText")
      .money
        .number {{ item.amount || '' }}
        .unit {{ item.unit || '' }}
      .desc {{item.subWord || ''}}
    template(v-else-if="showFreeText")
      .free-text(
        ) 免单特权
      .desc {{item.subWord || ''}}
    .award-block(v-else-if="getAward()") {{getAmount()}}
    .btn(
      v-if="vipOpen"
      @click.stop="firstStatus()"
      :class="{'btn-disabled': isDisabled, 'expand-style': item.afterVipExtendProperty}"
    ) {{getChangeName(item.btnName,item) || ''}}
      template(
        v-if="item.afterVipExtendProperty && item.afterVipExtendProperty"
      )
        ColumnCarousel.marquee(
          :dataList="getMarqueeText()"
          :autoplay="2000"
        )
          .item(slot-scope="slotProps" v-html="slotProps.itemData")
    .threshold(v-else-if="!freeRightsVersion()")
      .container(v-if="item.vipExtendProperty && item.vipExtendProperty")
        ColumnCarousel.marquee(
          :dataList="getMarqueeText()"
          :autoplay="2000"
        )
          .item(slot-scope="slotProps" v-html="slotProps.itemData")
      .card-change-it(v-else-if="isChangeIt===1" @click="changeIt")
        span 换掉
      .container(v-else-if="item.status === COUPON_STATUS.changeed")
        span 已更换
      .container(v-else)
        span 开通可用
  changeExpansionCardModalContainer(
    v-if="showChangeModal"
    :show.sync="showChangeModal"
    :openChangeType="3"
    :couponInfo="changeValue"
    :unOpenCouponGameAB="true"
  )
</template>
<script>
import { env } from '@hb/hbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { COUPON_STATUS, EXPAND_TYPE } from '@/pages/vip/consts';
import ColumnCarousel from '@/components/Carousel/ColumnCarousel.vue';
import marquee from './lottery-marquee.vue';
import changeExpansionCardModalContainer from './change-expansion-card-modal.vue';

export default {
  name: 'CouponOpenedLotteryNew',
  components: {
    marquee,
    ColumnCarousel,
    changeExpansionCardModalContainer,
  },
  props: {
    // 是否已开会员
    vipOpen: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    // 是否是换券弹窗的券
    isChangeIt: {
      type: Number,
      default: 0,
    },
  },
  inject: ['freeRightsVersion'],
  data() {
    return {
      env,
      showChangeModal: false,
      COUPON_STATUS,
    };
  },
  computed: {
    isDisabled() {
      if (this.getAward()) {
        return true;
      }      
      if(this.isChangeIt && this.item.status === COUPON_STATUS.changeed) {
        return true;
      }
      
      if (this.item.changeRecord) {
        if (this.item.changeRecord.btnName === '已使用') {
          return true;
        }
      }
      if (this.item && this.item.status) {
        return [COUPON_STATUS.unConfirm,
          COUPON_STATUS.achieve,
          COUPON_STATUS.fail,
          COUPON_STATUS.expired,
          COUPON_STATUS.wait].includes(this.item.status);
      }
      return false;
    },
    showFreeText() {
      if (this.item.changeRecord
        && this.item.changeRecord.expansionType === EXPAND_TYPE.free_expand) {
        return true;
      }
      return false;
    },
  },
  mounted() {
  },
  methods: {
    getChangeName(value, item) {
      if (item.status === COUPON_STATUS.receive) {
        if (item.afterVipExtendProperty) {
          return '';
        }
        return value;
      }
      if (([COUPON_STATUS.expansived, COUPON_STATUS.changeed].includes(item.status))
        && !this.isChangeIt && item.changeRecord) {
        if (item.changeRecord.btnName === '去使用') {
          return item.changeRecord.btnName;
        }
        return item.changeRecord.btnName;
      }
      return value;
    },
    firstStatus() {
      if (this.item.afterVipExtendProperty) {
        this.$emit('openExtend', this.item);
        return;
      }
      if (this.item.changeRecord) {
        this.$emit('click-btn', this.item.changeRecord);
        return;
      }
      this.$emit('click-btn', this.item);
    },
    openChangeModal() {
      if (this.vipOpen) return;
      if (this.item.vipExtendProperty) {
        this.changeValue = this.item;
        this.showChangeModal = true;
      }
    },
    changeIt() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_exchange_coupons_pop',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$emit('changeIt', 1, this.item);
    },
    getMarqueeText() {
      const { afterVipExtendProperty, vipExtendProperty } = this.item;
      const expandInfo = (afterVipExtendProperty && afterVipExtendProperty.length)
        ? afterVipExtendProperty[0] : vipExtendProperty || {};
      if (expandInfo) {
        const { expansionType } = expandInfo;
        let secondText = '';
        if (expansionType === EXPAND_TYPE.free_expand) {
          secondText = this.vipOpen
            ? '至免单'
            : '膨胀至<span style="font-size:0.15rem">免单</span>';
        } else {
          secondText = this.vipOpen
            ? `最高${expandInfo.propAmount}元`
            : `最高至<span style="font-size:0.15rem;">${expandInfo.propAmount}元</span>`;
        }
        const firstText = this.vipOpen ? '膨胀变大' : '开通后膨胀';
        return [firstText, secondText];
      }
      return [''];
    },
    getAward() {
      if (this.item.propType === 26) {
        return true;
      }
      if (this.item.status === 9 || this.item.status === 10) {
        if (this.item.changeRecord && this.item.changeRecord.propType === 26) {
          return true;
        }
        return false;
      }
      return false;
    },
    getAmount() {
      if ((this.item.status === 9 || this.item.status === 10) && this.item.changeRecord) {
        return this.item.changeRecord.amount;
      }
      return this.item.amount;
    },
    getGoodsPropDesc() {
      if ((this.item.status === 9 || this.item.status === 10) && this.item.changeRecord) {
        return this.item.changeRecord.goodsPropDesc;
      }
      return this.item.goodsPropDesc;
    },
  },
};
</script>
<style lang="less" scoped>
.coupons-container {
  position: relative;
  height: 0.9rem;
  flex-shrink: 0;
  width: 0.78rem;
  background-image: url('https://m.hellobike.com/resource/gallery/59/3ShCQVh2_Group%201707483362.png');
  background-repeat: no-repeat;
  background-size: 0.78rem 0.9rem;
  text-align: center;
  overflow: hidden;

  // 第四个margin-right为0
  &:nth-child(4n) {
    margin-right: 0;
  }

  &.disabled-coupon {
    opacity: 0.5;
  }

  .award-block {
    margin: 0.06rem auto 0.02rem;
    width: 0.38rem;
    height: 0.38rem;
    background: url('https://m.hellobike.com/resource/helloyun/08345/iBMsO8400i.png');
    background-size: 100% 100%;
    color: #7d3b2a;
    line-height: 0.38rem;
    text-align: center;
    font-family: "DIN Alternate", sans-serif;
    font-size: 0.14rem;
    font-weight: 700;
  }

  .marquee {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 0;
    height: 0.2rem;
    width: 100%;
    color: #fff;
    margin-top: 0.05rem;
    font-size: 0.12rem;

    .item {
      height: 0.2rem;
      width: 100%;
      text-align: center;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: visible;
      font-size: 0.12rem;
    }
  }

  .title {
    height: 0.12rem;
    font-weight: 500;
    font-size: 0.11rem;
    line-height: 0.12rem;
    text-align: center;
    margin-top: 0.03rem;
    color: rgba(36, 39, 41, 1);
  }

  .free-text {
    height: 0.16rem;
    line-height: 0.16rem;
    color: #ff5521;
    text-align: center;
    font-family: "PingFang SC", sans-serif;
    font-size: 0.14rem;
    font-weight: 600;
    margin-top: 0.08rem;
    margin-bottom: 0.07rem;
  }

  .money {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: end;
    margin-top: 0.02rem;
    height: 0.3rem;

    .number {
      height: 0.3rem;
      display: flex;
      align-items: center;
      font-family: "DIN Alternate", sans-serif;
      font-weight: 700;
      font-size: 0.26rem;
      color: rgba(36, 39, 41, 1);
    }

    .unit {
      height: 0.22rem;
      display: flex;
      align-items: center;
      margin-top: 0.1rem;
      margin-left: 0.02rem;
      font-weight: 400;
      font-size: 0.11rem;
      line-height: 0.23rem;
      color: rgba(165, 77, 8, 1);
    }
  }

  .desc {
    width: 100%;
    height: 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: -0.06rem auto 0;
    color: rgba(165, 77, 8, 1);
    font-size: 0.11rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .btn {
    font-family: "PingFang SC", sans-serif;
    font-weight: 500;
    font-size: 0.12rem;
    height: 0.2rem;
    display: inline-block;
    min-width: 0.56rem;
    margin-top: 0.05rem;
    padding: 0 0.08rem;
    box-sizing: border-box;
    line-height: 0.2rem;
    background: linear-gradient(94.85deg, rgba(255, 96, 93, 1), rgba(255, 79, 29, 1));
    border-radius: 0.06rem;
    color: rgba(255, 255, 255, 1);
  }

  .expand-style {
    position: relative;

    &::after {
      content: "";
      position: absolute;
      right: -0.09rem;
      bottom: 0;
      display: block;
      background-image: url('https://m.hellobike.com/resource/gallery/43/gjs6VMCr_8291928.png');
      background-size: contain;
      background-repeat: no-repeat;
      width: 0.1527rem;
      height: 0.2201rem;
      transform-origin: center bottom;
      animation: expandAnimation 2s ease-out infinite;
    }
  }

  .btn-disabled {
    background: transparent;
    color: rgba(165, 77, 8, 1);
  }

  .threshold {
    color: #a54d08;
    font-family: "PingFang SC", sans-serif;
    font-size: 0.11rem;
    font-weight: 500;
    height: 0.15rem;
    line-height: 0.15rem;
    position: relative;

    .container {
      margin-top: 0.09rem;
    }

    .marquee {
      font-size: 0.11rem;
      color: #ff4f1d;
      height: 0.15rem;
      margin-top: 0;

      .item {
        font-size: 0.11rem;
        color: #ff4f1d;
        height: 0.15rem;
        line-height: 0.15rem;
        align-items: baseline;
      }
    }
  }

  .card-change-it {
    margin: 0.04rem auto 0 auto;
    height: 0.2rem;
    width: 0.57rem;
    border-radius: 0.06rem;
    text-align: center;
    line-height: 0.2rem;
    color: #fff;
    background: #fb990f;
    font-size: 0.11rem;
    display: flex;
    justify-content: center;

    img {
      margin-top: 0.06rem;
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.03rem;
    }
  }
}

.free-rights-version {
  .disabled-coupon {
    opacity: 1;
  }

  .vip-open-card-content {
    background-image: url('https://m.hellobike.com/resource/gallery/1022/WXotF-qUKQ.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 0.8rem;
    height: 1.12rem;
    padding: 0;
  }

  .vip-unopen-card-content {
    background-image: url('https://m.hellobike.com/resource/gallery/1022/35w8EichUL.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 0.8rem;
    height: 0.82rem;
    padding: 0;
  }

  .coupons-container {
    .title {
      height: 0.248rem;
      font-weight: 500;
      font-size: 0.12rem;
      text-align: center;
      color: #000;
      display: flex;
      justify-content: center;
      align-items: center;

      .title-content {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 0.16rem;
          height: 0.16rem;
          display: inherit;
        }
      }

      img {
        // 根据实际需要调整图片的尺寸
        width: 0.12rem;
        height: 0.12rem;
        background-color: #fff;
        border-radius: 50%;
        margin-right: 0.02rem; // 可选：添加一些右边距以分隔图片和文字
      }
    }

    .money {
      margin-top: 0.025rem;
      height: auto;
      display: flex;
      align-items: baseline;

      .number {
        color: #6b0d00;
        font-family: "DIN Alternate", sans-serif;
        font-size: 0.26rem;
      }

      .unit {
        color: #6b0d00;
        font-family: "PingFang SC", sans-serif;
        font-size: 0.11rem;
      }
    }

    .desc {
      margin: 0 auto 0.059rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex-shrink: 0;
      color: #7f2c00;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 0.11rem;
      font-style: normal;
      font-weight: 400;
      line-height: 0.2rem;
      height: 0.12rem;
      opacity: 0.6;
    }

    .btn {
      color: #6b0d00;
      font-family: "PingFang SC", sans-serif;
      font-size: 0.12rem;
      font-style: normal;
      font-weight: 500;
      line-height: 0.24rem;
      margin-top: 0;
      width: 0.6rem;
      height: 0.24rem;
      border-radius: 0.24rem;
      background: linear-gradient(90deg, rgba(253, 225, 197, 0.92) 2.77%, #ffd2a5 99.97%);
    }

    .btn-disabled {
      opacity: 0.4;
    }

    .marquee {
      margin-top: 0;
      height: 0.22rem;
    }
  }
}

@keyframes expandAnimation {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  20% {
    transform: scale(1);
    opacity: 1;
  }

  25% {
    transform: scale(0.93);
  }

  30% {
    transform: scale(1);
  }

  35% {
    transform: scale(0.93);
  }

  40% {
    transform: scale(1);
  }
}
</style>
